import React, { useState, useEffect, memo } from 'react';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import getSentEmails from './sent-emails-data';
import sentEmailsColumns from './sent-emails-columns';
import sentEmailsFilterValue from './sent-emails-sort';

const gridStyle = { height: '100vh' };

const SentEmailsTable = ({ setOpenEditModal, setSelectedId }) => {
  const [sentEmails, setSentEmails] = useState([]);
  // For future: const [tablePreferences, setTablePreferences] = useState({});

useEffect(() => {
  const unsubscribe = getSentEmails((data) => {
    const sortedData = [...data].sort((a, b) => {
      // Convert ISO strings directly to timestamps
      const timeA = new Date(a.dateTime).getTime();
      const timeB = new Date(b.dateTime).getTime();
      return timeB - timeA; // Descending order (newest to oldest)
    });
    setSentEmails(sortedData);
  });
  return () => unsubscribe();
}, []);
  return (

      <ReactDataGrid
        idProperty="uniqueId"
        style={gridStyle}
        columns={sentEmailsColumns(setOpenEditModal, setSelectedId)}
        dataSource={sentEmails}
        emptyText="Loading…"
        enableFiltering
        defaultFilterValue={sentEmailsFilterValue}
        pagination
        defaultLimit={20}
        rowHeight={60}
        showCellBorders={'horizontal'}
        enableKeyboardNavigation
        columnMenu={{ lockable: false }}
      />
    
  );
};

export default memo(SentEmailsTable); 